import { Link } from 'react-router-dom';

const PoliticaSeguranca = () => {
  return (
    <div style={{ 
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
      minHeight: '100vh',
      backgroundColor: '#f8f9fa'
    }}>
      {/* Header */}
      <header style={{
        backgroundColor: '#ffffff',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        padding: '1rem 0'
      }}>
        <div className="container">
          <div className="d-flex align-items-center justify-content-between">
            <Link to="/" className="d-flex align-items-center text-decoration-none">
              <img 
                src="/img/logo-icone.png" 
                alt="Sophya" 
                className="me-2"
                style={{ height: '40px' }}
              />
              <span className="fw-bold text-primary fs-4">Sophya</span>
            </Link>
            <Link to="/" className="btn btn-outline-primary">
              <i className="fas fa-arrow-left me-2"></i>
              Voltar ao Início
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10 col-xl-8">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-5">
                {/* Title */}
                <div className="text-center mb-5">
                  <i className="fas fa-shield-alt text-primary" style={{ fontSize: '4rem' }}></i>
                  <h1 className="mt-3 mb-2 fw-bold">Política de Segurança</h1>
                  <p className="text-muted">
                    Sistema Sophya - Gerenciamento de Consultórios de Psicologia
                  </p>
                  <p className="text-muted mb-0">
                    <small>Última atualização: Novembro de 2025</small>
                  </p>
                </div>

                {/* Introdução */}
                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="fas fa-info-circle text-primary me-2"></i>
                    Compromisso com a Segurança
                  </h2>
                  <p className="text-muted">
                    No Sophya, levamos a segurança dos dados dos nossos usuários e seus pacientes 
                    extremamente a sério. Esta política descreve as medidas técnicas e organizacionais 
                    que implementamos para proteger as informações confiadas ao nosso sistema.
                  </p>
                  <div className="alert alert-info" role="alert">
                    <i className="fas fa-certificate me-2"></i>
                    <strong>Nosso sistema está em total conformidade com:</strong> LGPD (Lei nº 13.709/2018), 
                    Resoluções CFP/CRP para prontuários digitais e atendimento online.
                  </div>
                </section>

                {/* Conformidade Legal */}
                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="fas fa-balance-scale text-primary me-2"></i>
                    Conformidade Legal e Regulatória
                  </h2>
                  
                  <div className="mb-4">
                    <h5 className="fw-bold">
                      <i className="fas fa-check-circle text-success me-2"></i>
                      Lei Geral de Proteção de Dados (LGPD)
                    </h5>
                    <p className="text-muted mb-2">
                      O Sophya está em total conformidade com a Lei nº 13.709/2018, garantindo:
                    </p>
                    <ul className="text-muted">
                      <li>Proteção adequada de dados pessoais e sensíveis de saúde</li>
                      <li>Criptografia de informações clínicas conforme Art. 46, §1º</li>
                      <li>Controles de acesso e auditoria conforme orientações da ANPD</li>
                      <li>Procedimentos de notificação de incidentes de segurança</li>
                      <li>Direitos dos titulares de dados garantidos (acesso, correção, exclusão)</li>
                    </ul>
                  </div>

                  <div className="mb-4">
                    <h5 className="fw-bold">
                      <i className="fas fa-check-circle text-success me-2"></i>
                      Conselho Federal de Psicologia (CFP) e Conselhos Regionais (CRP)
                    </h5>
                    <p className="text-muted mb-2">
                      Cumprimos todas as resoluções do CFP/CRP relacionadas à prática profissional:
                    </p>
                    <ul className="text-muted">
                      <li><strong>Resolução CFP 001/2009:</strong> Sigilo absoluto de prontuários psicológicos</li>
                      <li><strong>Resolução CFP 011/2018:</strong> Segurança em atendimentos por meios tecnológicos</li>
                      <li><strong>Prazo de guarda:</strong> Prontuários mantidos por 20 anos com segurança</li>
                      <li>Garantia de confidencialidade e integridade dos registros clínicos</li>
                    </ul>
                  </div>

                  <div className="alert alert-success" role="alert">
                    <strong>
                      <i className="fas fa-graduation-cap me-2"></i>
                      Para Psicólogos:
                    </strong> Usar o Sophya protege você de possíveis sanções éticas do CRP por 
                    inadequação no armazenamento de prontuários, garantindo sua conformidade profissional.
                  </div>
                </section>

                {/* Infraestrutura */}
                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="fas fa-server text-primary me-2"></i>
                    Infraestrutura de Nuvem Segura
                  </h2>
                  <p className="text-muted mb-3">
                    O Sophya é hospedado na infraestrutura Oracle, uma das plataformas de nuvem 
                    mais seguras e confiáveis do mundo.
                  </p>
                  
                  <div className="card bg-light border-0 mb-3">
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-md-3 text-center mb-3 mb-md-0">
                          <img 
                            src="/img/oracle-cloud-logo.png" 
                            alt="Oracle" 
                            style={{ maxWidth: '150px', height: 'auto' }}
                            onError={(e) => {
                              const target = e.target as HTMLImageElement;
                              target.style.display = 'none';
                            }}
                          />
                        </div>
                        <div className="col-md-9">
                          <h6 className="fw-bold mb-2">Benefícios da Infraestrutura:</h6>
                          <ul className="mb-0 text-muted">
                            <li>Datacenter com certificação <strong>ISO/IEC 27001</strong> (segurança da informação)</li>
                            <li>Criptografia em trânsito (TLS 1.3) e em repouso</li>
                            <li>Backup automático diário com redundância geográfica</li>
                            <li>Disponibilidade de <strong>99.9%</strong> garantida por SLA</li>
                            <li>Monitoramento 24/7 por equipe especializada</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                {/* Proteção de Dados */}
                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="fas fa-lock text-primary me-2"></i>
                    Proteção de Dados Clínicos
                  </h2>
                  <p className="text-muted mb-3">
                    Implementamos múltiplas camadas de segurança para proteger os dados dos seus pacientes:
                  </p>

                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="card h-100 border-primary">
                        <div className="card-body">
                          <h6 className="fw-bold mb-2">
                            <i className="fas fa-shield-virus text-primary me-2"></i>
                            Criptografia de Ponta
                          </h6>
                          <p className="text-muted mb-0 small">
                            Dados sensíveis protegidos com algoritmos de criptografia de nível militar. 
                            Informações clínicas são ilegíveis sem autorização adequada.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="card h-100 border-primary">
                        <div className="card-body">
                          <h6 className="fw-bold mb-2">
                            <i className="fas fa-user-lock text-primary me-2"></i>
                            Controle de Acesso Rigoroso
                          </h6>
                          <p className="text-muted mb-0 small">
                            Cada usuário acessa apenas os dados de seu próprio consultório. 
                            Isolamento total entre diferentes profissionais e empresas.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="card h-100 border-primary">
                        <div className="card-body">
                          <h6 className="fw-bold mb-2">
                            <i className="fas fa-history text-primary me-2"></i>
                            Auditoria Completa
                          </h6>
                          <p className="text-muted mb-0 small">
                            Registro detalhado de todos os acessos aos dados sensíveis, 
                            permitindo rastreabilidade total para fins de auditoria e compliance.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="card h-100 border-primary">
                        <div className="card-body">
                          <h6 className="fw-bold mb-2">
                            <i className="fas fa-database text-primary me-2"></i>
                            Backup Automático
                          </h6>
                          <p className="text-muted mb-0 small">
                            Backups diários automáticos com criptografia. Seus dados estão seguros 
                            contra perda acidental ou desastres.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                {/* Boas Práticas */}
                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="fas fa-user-shield text-primary me-2"></i>
                    Boas Práticas para Usuários
                  </h2>
                  <p className="text-muted mb-3">
                    A segurança é uma responsabilidade compartilhada. Recomendamos que você:
                  </p>
                  
                  <div className="alert alert-warning" role="alert">
                    <h6 className="fw-bold mb-2">
                      <i className="fas fa-exclamation-triangle me-2"></i>
                      Recomendações Importantes:
                    </h6>
                    <ul className="mb-0">
                      <li>Use senhas fortes e únicas (mínimo 8 caracteres, letras, números e símbolos)</li>
                      <li>Nunca compartilhe suas credenciais de acesso com terceiros</li>
                      <li>Faça logout ao sair do sistema, especialmente em computadores compartilhados</li>
                      <li>Mantenha seu dispositivo protegido com antivírus atualizado</li>
                      <li>Evite acessar o sistema em redes Wi-Fi públicas sem VPN</li>
                      <li>Reporte imediatamente qualquer atividade suspeita à nossa equipe</li>
                    </ul>
                  </div>
                </section>

                {/* Incidentes */}
                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="fas fa-bell text-primary me-2"></i>
                    Resposta a Incidentes
                  </h2>
                  <p className="text-muted">
                    Mantemos um plano robusto de resposta a incidentes de segurança:
                  </p>
                  <ul className="text-muted">
                    <li>Monitoramento contínuo de ameaças e vulnerabilidades</li>
                    <li>Equipe dedicada para resposta rápida a incidentes</li>
                    <li>Notificação imediata aos usuários afetados em caso de violação de dados</li>
                    <li>Comunicação transparente com autoridades competentes (ANPD)</li>
                    <li>Investigação completa e medidas corretivas imediatas</li>
                  </ul>
                </section>

                {/* Atualizações */}
                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">
                    <i className="fas fa-sync-alt text-primary me-2"></i>
                    Atualizações Contínuas
                  </h2>
                  <p className="text-muted">
                    Nosso compromisso com a segurança é contínuo:
                  </p>
                  <ul className="text-muted">
                    <li>Aplicação regular de patches de segurança</li>
                    <li>Revisão periódica de políticas e procedimentos</li>
                    <li>Testes de penetração e auditorias externas</li>
                    <li>Treinamento contínuo da equipe em boas práticas de segurança</li>
                    <li>Acompanhamento das últimas ameaças e tendências de cibersegurança</li>
                  </ul>
                </section>

                {/* Contato */}
                <section>
                  <h2 className="h4 fw-bold mb-3">
                    <i className="fas fa-envelope text-primary me-2"></i>
                    Entre em Contato
                  </h2>
                  <p className="text-muted mb-3">
                    Tem dúvidas sobre nossa política de segurança ou precisa reportar um incidente?
                  </p>
                  <div className="card bg-light border-0">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6 mb-3 mb-md-0">
                          <h6 className="fw-bold mb-2">
                            <i className="fas fa-headset text-primary me-2"></i>
                            Suporte Técnico
                          </h6>
                          <p className="mb-1">
                            <a href="mailto:contato@dhtech.com.br" className="text-decoration-none">
                              contato@dhtech.com.br
                            </a>
                          </p>
                          <p className="mb-0 text-muted small">Resposta em até 24h úteis</p>
                        </div>
                        <div className="col-md-6">
                          <h6 className="fw-bold mb-2">
                            <i className="fab fa-whatsapp text-success me-2"></i>
                            WhatsApp
                          </h6>
                          <p className="mb-1">
                            <a 
                              href="https://api.whatsapp.com/send?phone=5511936189517" 
                              target="_blank" 
                              rel="noopener noreferrer"
                              className="text-decoration-none"
                            >
                              +55 11 93618-9517
                            </a>
                          </p>
                          <p className="mb-0 text-muted small">Seg-Sex, 9h às 18h</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                {/* Footer */}
                <div className="text-center mt-5 pt-4 border-top">
                  <p className="text-muted mb-2">
                    <i className="fas fa-shield-alt text-primary me-2"></i>
                    Seu consultório e seus pacientes protegidos com Sophya
                  </p>
                  <div className="d-flex gap-2 justify-content-center flex-wrap">
                    <span className="badge bg-primary-subtle text-primary">LGPD</span>
                    <span className="badge bg-primary-subtle text-primary">CFP/CRP</span>
                    <span className="badge bg-primary-subtle text-primary">ANPD</span>
                    <span className="badge bg-primary-subtle text-primary">ISO 27001</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoliticaSeguranca;
